/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_cat_meta_title = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category} Converter — Free Online | Toolverse`)
};

const es_uc_cat_meta_title = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversor de ${i?.category} — En línea y gratuito | Toolverse`)
};

const de_uc_cat_meta_title = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category}-Umrechner — Kostenlos online | Toolverse`)
};

const nl_uc_cat_meta_title = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category} Convertor — Gratis Online | Toolverse`)
};

const fr_uc_cat_meta_title = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convertisseur ${i?.category} — Gratuit en ligne | Toolverse`)
};

const it_uc_cat_meta_title = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convertitore di ${i?.category} — Online gratuito | Toolverse`)
};

const pt_br2_uc_cat_meta_title = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversor de ${i?.category} — Online Gratuito | Toolverse`)
};

const pt_uc_cat_meta_title = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category} Conversor — Gratuito Online | Toolverse`)
};

const ja_uc_cat_meta_title = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category}コンバーター — 無料オンライン | Toolverse`)
};

const zh_uc_cat_meta_title = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ category: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_cat_meta_title = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_cat_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_cat_meta_title", locale)
	if (locale === "en") return en_uc_cat_meta_title(inputs)
	if (locale === "es") return es_uc_cat_meta_title(inputs)
	if (locale === "de") return de_uc_cat_meta_title(inputs)
	if (locale === "nl") return nl_uc_cat_meta_title(inputs)
	if (locale === "fr") return fr_uc_cat_meta_title(inputs)
	if (locale === "it") return it_uc_cat_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_uc_cat_meta_title(inputs)
	if (locale === "pt") return pt_uc_cat_meta_title(inputs)
	if (locale === "ja") return ja_uc_cat_meta_title(inputs)
	return zh_uc_cat_meta_title(inputs)
};